/**
 * ユーザー作成ページ専用i18n定数
 */

export const USER_CREATE_I18N = {
  // バックリンク
  backLink: {
    userList: $localize`:@@admin.userCreate.backLink.userList:ユーザー`,
  },

  // ページタイトル
  title: {
    userCreate: $localize`:@@admin.userCreate.title.userCreate:ユーザー登録`,
  },

  // サブタイトル
  subtitle: {
    description: $localize`:@@admin.userCreate.subtitle.description:現在のセクションにユーザーを登録します。`,
  },

  // 性別オプション
  sex: {
    male: $localize`:@@admin.userCreate.sex.male:男性`,
    female: $localize`:@@admin.userCreate.sex.female:女性`,
    other: $localize`:@@admin.userCreate.sex.other:その他`,
  },

  // ステータス
  status: {
    active: $localize`:@@admin.userCreate.status.active:有効`,
    inactive: $localize`:@@admin.userCreate.status.inactive:無効`,
  },

  // アカウントグループ
  accountGroup: {
    staff: $localize`:@@admin.userCreate.accountGroup.staff:スタッフ`,
    user: $localize`:@@admin.userCreate.accountGroup.user:ユーザー`,
  },

  // ボタン
  button: {
    close: $localize`:@@admin.userCreate.button.close:閉じる`,
  },

  // メッセージ
  message: {
    createSuccess: $localize`:@@admin.userCreate.message.createSuccess:登録が完了しました。`,
    createError: $localize`:@@admin.userCreate.message.createError:登録に失敗しました。再度お試しください。`,
  },
} as const;

export type UserCreateI18n = typeof USER_CREATE_I18N;
